// extracted by mini-css-extract-plugin
var _1 = "sHb5ADYd";
export { _1 as "control" }
